import React, { useEffect, memo, useState } from 'react'
import { useDispatch } from 'react-redux'
import { setChildPageName, setPageName } from '../../../../../redux'
import { getData } from '../../../../../assets/scripts/GeneralFunctions'
import CategoriesBox from './category/CategoriesBox'

function CarCategories() {
  const [carModels, setCarModels] = useState([])
  const dispatch = useDispatch()

  useEffect(() => {
    async function fetchData() {
      dispatch(setPageName('cars'))
      dispatch(setChildPageName('categories'))

      let apiResult = await getData('admin/site-options/car-models', 'get', {}, true)
      if (apiResult) {
        if (apiResult?.status === 200) {
          let result_data = apiResult?.data
          setCarModels(result_data?.car_models)
        }
      }
    }
    fetchData()
  }, [])

  return (
    <div className={'md:py-8'}>
      <CategoriesBox setCarModels={setCarModels} carModels={carModels} />
    </div>
  )
}

export default memo(CarCategories)
